import React, { memo } from 'react';
import { Input, InputVariants } from '../../UI';

interface FormField {
  name: string;
  label: string;
  type: string;
}

interface FormProps {
  formFields: FormField[];
  formData?: Record<string, string>;
  errors?: Record<string, string>;
  onInputChange: (name: string, value: string) => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  hasError: boolean;
}

export const Form = memo<FormProps>(({ formFields, formData, errors, onInputChange, onSubmit, hasError }) => {

  return (
    <form onSubmit={onSubmit}>
      {
        formFields.map(({ name, label, type }) => {
          return <Input
            variant={InputVariants.OUTLINE}
            type={type}
            id={name}
            name={name}
            value={formData?.[name] || ''}
            onChange={(value: string) => onInputChange(name, value)}
            onBlur={() => {}}
            hasError={!!errors?.[name]}
            errorMessage={errors?.[name]}
            key={label}
          />;
        })
      }
      <button disabled={hasError} className='p-6 bg-slate-400 disabled:bg-yellow-200'>Submit</button>
    </form>
  );
});
